export default __webpack_public_path__ + "static/Vanessa-49fcc84c399cdbde99c2410c8a418319.png";